query allExtBasketballPlayers(
  $first: Int,
  $offset: Int,
  $filter: BasketballPlayerMappingFilter,
  ) {
  allBasketballPlayerMappings(
      first: $first,
      offset: $offset,
      filter: $filter
    ) {
    nodes {
      extId
      extRef
      feed
      mappingType
      mappingId
      createdAt
      createdBy
      intId
      playerIndex
      mappedEntity {
        name
        source
        playerId
        playerIndex
      }
      playerTeamMapping: playerTeamMappingsByFeedAndPlayerExtId {
        nodes {
          discriminator
          team: basketballTeamMapping { 
            extRef
          }
        }
      }
    }
    totalCount
  }
}
